import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onConfirm: (closePortal: () => void) => Promise<void>
  onClose: () => void
}

const DeletePeriodModal = ({ onConfirm, onClose }: Props) => {
  const title = i18n.t('settings.work_schedule.period_section.remove_period.title')

  const description = i18n.t(
    'settings.work_schedule.period_section.remove_period.description.fallback_to_default'
  )

  const submitText = i18n.t('settings.work_schedule.period_section.remove_period.submit.remove')

  const footer = (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('settings.work_schedule.cancel')}
      </Button>
      <Button submit>{submitText}</Button>
    </>
  )

  return (
    <Modal
      illustration={'delete-cross'}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onConfirm}
      footer={footer}
    ></Modal>
  )
}

export default DeletePeriodModal
